module.exports = {"title":"Request a Demo","disclaimer":"Disclaimer: Templates and policies from HRdownloads.com are provided for clients of our service. Customers may use this document as is, or as a starting point for their own documents. HRdownloads.com assumes no responsibility for the enforcement or effectiveness of its templates and policies. Always consult legal counsel before implementing any new policies or procedures at your organization."}


//////////////////
// WEBPACK FOOTER
// ./src/translations/en/request-demo.json
// module id = YQyw
// module chunks = 0